// ----------------------
// <auto-generated>
// Generated using the script apiGenerator.js
// </auto-generated>
// -----------------------
import { configuration } from 'config/constants';
import {
    AddSubscriptionsClient,
    AlertsClient,
    AppContextsClient,
    CloseSubscriptionsClient,
    ConfigurationsClient,
    ExclusionCategoriesJournalistClient,
    HealthClient,
    LogsClient,
    SearchSubscriptionsClient,
    SettingsClient,
    StatisticsClient,
    SubscriptionSectorsClient,
    TargetingsClient,
    ThirdPartiesClient,
    UsersClient,
} from './SubscriptionApiClient';
import { http } from 'services/ApiService/Http';

const { baseApiUrls: { subscription: baseApiUrl } } = configuration;

export const AddSubscriptionsApi = new AddSubscriptionsClient(baseApiUrl, http);
export const AlertsApi = new AlertsClient(baseApiUrl, http);
export const AppContextsApi = new AppContextsClient(baseApiUrl, http);
export const CloseSubscriptionsApi = new CloseSubscriptionsClient(baseApiUrl, http);
export const ConfigurationsApi = new ConfigurationsClient(baseApiUrl, http);
export const ExclusionCategoriesJournalistApi = new ExclusionCategoriesJournalistClient(baseApiUrl, http);
export const HealthApi = new HealthClient(baseApiUrl, http);
export const LogsApi = new LogsClient(baseApiUrl, http);
export const SearchSubscriptionsApi = new SearchSubscriptionsClient(baseApiUrl, http);
export const SettingsApi = new SettingsClient(baseApiUrl, http);
export const StatisticsApi = new StatisticsClient(baseApiUrl, http);
export const SubscriptionSectorsApi = new SubscriptionSectorsClient(baseApiUrl, http);
export const TargetingsApi = new TargetingsClient(baseApiUrl, http);
export const ThirdPartiesApi = new ThirdPartiesClient(baseApiUrl, http);
export const UsersApi = new UsersClient(baseApiUrl, http);
